import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';

import { StarredCellRendererComponent } from './starred-cell-renderer.component';

@NgModule({
  imports: [CommonModule, MatIconModule, MatButtonModule],
  declarations: [StarredCellRendererComponent],
  exports: [StarredCellRendererComponent],
})
export class StarredCellRendererModule {}
